import Typograf from "typograf";

declare global {
	interface Window {
		ym: any;
	}
}
export const sendEvent = (eventName: string) => {
	if (window.ym && typeof window.ym === "function") {
		window.ym(98610025, "reachGoal", eventName);
	} else {
		console.warn("Yandex Metrika is not initialized");
	}
};

const typo = new Typograf({ locale: ["ru", "en-US"] });

export const getFixedText = (input: string) => {
	return typo.execute(input);
};

const audio = new Audio("/sounds/click.mp3");
audio.volume = 0.15;

export const playClick = (musicPlay = false) => {
	if (!musicPlay) return;
	audio.currentTime = 0;
	audio.play().catch(() => {});
};
